export default "__VITE_ASSET__CfS2FMMF__"